export default class FreeVoteRequest {
    tableID: string;
    adminToken: string;

    constructor(tableID: string, adminToken: string) {
        this.tableID = tableID;
        this.adminToken = adminToken;
    }
}
